/*
 *  -----------------------------------------------------------------------
 *    <copyright file="features.ts" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

export interface IFeature {
    id: string;
    enabled: boolean;
}

export type IFeatures = Record<
    | 'AdminRisks'
    | 'AdminUsers'
    | 'CentralMonitoring'
    | 'SubjectMonitoring'
    | 'ClientLogs'
    | 'RiskAssessment'
    | 'SendLogReports'
    | 'DataQuality',
    IFeature
>;

const Features: IFeatures = {
    RiskAssessment: {
        id: 'risk-assessment',
        enabled: true,
    },
    SendLogReports: {
        id: 'send-log-reports',
        enabled: true,
    },
    CentralMonitoring: {
        id: 'central-monitoring',
        enabled: true,
    },
    SubjectMonitoring: {
        id: 'subject-monitoring',
        enabled: true,
    },
    AdminUsers: {
        id: 'admin-users',
        enabled: true,
    },
    AdminRisks: {
        id: 'admin-risks',
        enabled: true,
    },
    ClientLogs: {
        id: 'client-logs',
        enabled: true,
    },
    DataQuality: {
        id: 'data-quality',
        enabled: true,
    },
};

export default Features;
